export default __webpack_public_path__ + "static/media/add-button-white.f055d92e.svg";